import { Empty } from "antd";
import classNames from "classnames";
import { track } from "@amplitude/analytics-browser";
import { useSSRContext } from "../../context/SSRContext";
import SelectionItem, { SelectionItemData } from "../SelectionItem/SelectionItem";

export type ItemSelectionItem<T extends { code: string }> = SelectionItemData & { option: T };

type ItemSelectionProps<T extends { code: string }> = {
  ssrType: "baggages" | "meals";
  items?: ItemSelectionItem<T>[];
  trackLabel: string;
  className?: string;
};

export default function ItemSelection<T extends { code: string }>({ ssrType, items, trackLabel, className }: ItemSelectionProps<T>) {
  const { cursor, getSSRItem, updateSSRItem } = useSSRContext();
  const values = getSSRItem(ssrType, cursor.passengerId) as Record<string, T>;

  const isEmpty = !items?.length;
  if (isEmpty)
    return (
      <div className="flex items-center justify-center">
        <Empty />
      </div>
    );

  return (
    <div className={classNames("grid w-full flex-1 auto-rows-fr gap-4 lg:gap-5", className)}>
      {items?.map(({ option, ...item }) => {
        const selected = values?.[option.code]?.code === option.code;
        const handleClick = () => {
          track(`${trackLabel} ${selected ? "Unselected" : "Selected"}`, { ...option });
          updateSSRItem(ssrType, selected ? {} : { [option.code]: option });
        };
        return (
          <div key={`${option.code}-${cursor.passengerId}-${cursor.flightId}`} onClick={handleClick} className="flex items-center">
            <SelectionItem {...item} selected={selected} />
          </div>
        );
      })}
    </div>
  );
}
